import styled from 'styled-components'

const MyDiv = styled.div`
.ka{
    border: solid 1px #cecece;
}
.ka-table-wrapper{
    border-bottom: solid 1px #cecece;
}
.align_switch{
    display: flex;
    align-items: center;
    justify-content: center;
  }
.ka-thead-cell{
    font-weight: 600;
    color: #000;
    font-size: 15px;
    font-family: "Arial";
    background-color: #eee;
    padding: 4px;
    border-right: 1px solid #cecece;
    text-transform: capitalize;
}
.ka-thead-cell:last-child{
    border-right: 0;
}
.ka-thead-row:nth-child(2) .ka-thead-fixed{
    padding-bottom: 5px;
}
.ka-thead{
    border-bottom: solid 1px #cecece;
}
.ka-row{
    border-top: 0;
    border-bottom: 1px solid #cecece;
    cursor:pointer
}
.group-line-child-row:hover{
    background-color: #C7E4C6 !important;
    cursor:pointer
}
.ka-row:hover{
    background-color: #C7E4C6 !important;
    cursor:pointer

}
.ka-row:last-child{
    border-bottom: 0;
}
.ka-cell{
    border-right: 1px solid #cecece;
}
.ka-cell:last-child{
    border-right: 0;
}
tbody .ka-row:nth-of-type(even){
    background-color: #f3f3f3;
}
.ka-cell{
    color: #333;
    font-size: 14px;
    // padding: 3px 10px;
    padding: 4px;
    line-height: 20px;
    word-break: break-all;
}
.ka-paging-sizes-active{
    align-items: center;
    padding: 10px;
}

.ka-row-selected{
    background-color: #F7FcFd!important;
}
.ka-input{
    border: 1px solid #b1b1b1;
    height: 30px;
    padding: 0px 10px;
    border-radius: 4px;
}
.ka-input:focus-visible{
    outline: 0;
}
.ka-paging-page-index, .ka-paging-size{
    min-width: 32px;
    height: 32px;
    padding: 0px 6px;
    line-height: 30px;
    border-radius: 4px;
    border: 1px solid #ccc;
    font-family: "Arial";
}
.ka-paging-page-index-active, .ka-paging-size-active{
    color: #fff;
    background-color: #333;
    border: 1px solid transparent;
    font-weight: 600;
}
.icon_btn svg{
    width: 18px;
    height: 18px;
}
.icon_btn_flag{
    width: 24px;
    height: 24px;
}
.edit{
    color: #333;
}
.delete{
    color: #a43738;
}
.cell_btn{
    color: #000;
}
.checked{
    color: #279a24;
}
.icon_btn_flag_default{
    width: 100%;
    height: 25px;
    border-radius: 0;
}

.ka-thead-cell-height{
    height: auto;
}
.ka-thead-fixed .ka-thead-cell-wrapper .ka-thead-cell-content-wrapper .MuiCheckbox-root {
    padding: 0;
}
.ka-row .ka-cell .ka-cell-text .MuiCheckbox-root {
    padding: 0;
}
.ka-row .ka-cell .ka-cell-editor .MuiCheckbox-root {
    padding: 0;
  }
.ka-thead-row:nth-child(1) .ka-thead-fixed{
    z-index: 11;
}
.ka-thead-row:nth-child(2) .ka-thead-fixed{
    top: 0!important;
}
`
export default MyDiv
